import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const branchURL = `api/v1/tenant-app/branch`;

//obtaining the paginated data
export const getBranch = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${branchURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};
//obtaining all fiscal sessions
export const getAllBranch = () => axiosInstance.get(`${branchURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageBranch = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${branchURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getBranchById = (id) => axiosInstance.get(`${branchURL}/retrieve/${id}`);

//creating function
export const createBranch = (body) => axiosInstance.post(`${branchURL}/create`, body);
//updating function
export const updateBranch = (id, body) => axiosInstance.patch(`${branchURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${branchURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataBranchName = (e, cancelToken) =>
  axiosInstance.get(`${branchURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
